import { api } from '../api';
import type { PaginatedResponse } from '@/types/common';
import type {
  BulkActionCookingSessionsPayload,
  BulkActionResult,
  CookingSession,
  CookingSessionCapacity,
  CookingSessionStats,
  CreateCookingSessionPayload,
  CookingSessionSource,
  ListCookingSessionsParams,
  UpdateCookingSessionPayload,
} from '@/types/cooking-session';

function buildQs(params: Record<string, unknown>): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v == null) continue;
    if (Array.isArray(v)) v.forEach((item) => sp.append(k, String(item)));
    else sp.set(k, String(v));
  }
  const qs = sp.toString();
  return qs ? `?${qs}` : '';
}

export const cookingSessionRequests = {
  list: (params?: ListCookingSessionsParams) =>
    api.get<PaginatedResponse<CookingSession>>(`/cooking-sessions${buildQs({ ...params })}`),

  stats: (params?: { locationId?: number; source?: CookingSessionSource }) =>
    api.get<CookingSessionStats>(`/cooking-sessions/stats${buildQs({ ...params })}`),

  create: (data: CreateCookingSessionPayload) =>
    api.post<CookingSession>('/cooking-sessions', data),

  update: (id: number, data: UpdateCookingSessionPayload) =>
    api.patch<CookingSession>(`/cooking-sessions/${id}`, data),

  /** Finishes the current stage of a COOKING session and starts the next. */
  nextStage: (id: number) =>
    api.post<CookingSession>(`/cooking-sessions/${id}/next-stage`, {}),

  remove: (id: number) =>
    api.delete<{ deleted: boolean }>(`/cooking-sessions/${id}`),

  bulkAction: (data: BulkActionCookingSessionsPayload) =>
    api.patch<BulkActionResult>('/cooking-sessions/bulk', data),

  capacity: (params?: { locationId?: number; includeCookingNow?: boolean; chefs?: number; windowMinutes?: number; source?: CookingSessionSource }) =>
    api.get<CookingSessionCapacity>(`/cooking-sessions/capacity${buildQs({ ...params })}`),
};
